import { useState, useCallback } from 'react';
import { useAuth } from '../contexts/AuthContext';

export function useSchedulePermissions() {
  const { user } = useAuth();
  const [selectedJobs, setSelectedJobs] = useState(new Set());
  const [editingJob, setEditingJob] = useState(null);

  // Check if user can edit jobs based on their role - now includes PROPERTY_MANAGER
  const canEditJobs = user?.role === 'ADMIN' || user?.role === 'HOUSEKEEPER_MANAGER' || user?.role === 'PROPERTY_MANAGER';

  // Check if user can view canceled jobs
  const canViewCanceledJobs = ['ADMIN', 'GUEST_APP_MANAGER', 'PROPERTY_MANAGER', 'HOUSEKEEPER_MANAGER'].includes(user?.role);

  // Handle job selection
  const onJobSelect = useCallback((jobId) => {
    setSelectedJobs(prev => {
      const newSelected = new Set(prev);
      if (newSelected.has(jobId)) {
        newSelected.delete(jobId);
      } else {
        newSelected.add(jobId);
      }
      return newSelected;
    });
  }, []);

  // Handle job edit
  const onJobEdit = useCallback((job) => {
    if (!canEditJobs) return;
    setEditingJob(job);
  }, [canEditJobs]);

  // Handle closing the edit modal
  const closeEditModal = useCallback(() => {
    setEditingJob(null);
  }, []);

  return {
    selectedJobs,
    onJobSelect,
    onJobEdit,
    canEditJobs,
    canViewCanceledJobs,
    editingJob,
    closeEditModal
  };
} 